<template>
  <div>
    <v-flex class="d-flex justify-space-between">
      <!-- <div class="col-5 ml-0 pl-0">
        <v-text-field
          outlined
          dense
          append-icon="mdi-magnify"
          v-model="users.search"
          :label="$t('searchLabel')"
          single-line
          hide-details
        >
        </v-text-field>
      </div> -->
<!--      <v-spacer></v-spacer>-->
      <div class="">
<!--        <v-btn class="white&#45;&#45;text" color="primary my-2" @click="createUserDialog = true">-->
<!--          <v-icon left class="mr-4"> mdi-account-multiple-plus </v-icon>-->
<!--          {{ $t("addUserLabel") }}-->
<!--        </v-btn>-->
        <v-dialog v-model="createUserDialog" max-width="1200px">
          <v-card class="pa-10">
            <v-card-title>
              <span class="headline">{{ $t("addUserLabel") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field outlined v-model="newWTSUser.firstName" :rules="newWTSUserRules.name"
                      :label="$t('nameFormLabel')" hide-details="auto">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field outlined v-model="newWTSUser.lastName" :rules="newWTSUserRules.lastName"
                      :label="$t('surnameFormLabel')" hide-details="auto">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field outlined v-model="newWTSUser.email" :label="$t('emailFormLabel')" hide-details="auto"
                      :rules="newWTSUserRules.email"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field outlined v-model="newWTSUser.personalNumber" :label="$t('personalNumberFormLabel')"
                      hide-details="auto" :rules="newWTSUserRules.number"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="d-flex justify-center align-center">
              <v-btn :disabled="!validated" width="150" class="green white--text px-10" @click="registerUser">{{
                $t("createUserLabel")
              }}</v-btn>
              <v-btn width="150" class="primary px-2" color="" @click="createUserDialog = false">{{ $t("cancelLabel") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-flex>
    <v-data-table :footer-props="users.footerProps" :headers="users.headers" :options.sync="options" :server-items-length="1" :items="users.values" :loading="loading"
      :loading-text="$t('tableLoadingLabel')">
      <template #item.active="{item}">
        {{item.active ? $t('trueLabel') : $t('falseLabel') }}
      </template>
      <template #item.actions="{ item }">
        <v-btn min-width="100px" v-if="item.locked" @click="
                  () => {
                    selectedUser = item;
                    isLock = false;
                    isUnlock = true;
                    lockUserDialog = true;
                  }
                " class="white--text" small color="green my-2">
          <v-icon left class="mr-4"> mdi-account-cog </v-icon>
          {{ $t("unlockLabel") }}
        </v-btn>
        <v-btn min-width="100px" v-else class="white--text" @click="
                  () => {
                    selectedUser = item;
                    isLock = true;
                    isUnlock = false;
                    lockUserDialog = true;
                  }" small color="red my-2">
          <v-icon left class="mr-4"> mdi-account-cog </v-icon>
          {{ $t("lockLabel") }}
        </v-btn>
        <template>
          <v-btn min-width="100px" class="ml-4 primary--text" small outlined
            :to="{ name: 'SalesPartnerCompanyDetails' , params: {companyId: companyId, userId: item.id} }">{{ $t("viewUserLabel") }}</v-btn>
        </template>
      </template>
      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>

    <v-pagination v-model="page" :length="pageCount" @input="getWertheimSales"></v-pagination>
    <v-dialog v-model="lockUserDialog" max-width="800px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">
          <span class="headline">{{
                  isLock ? $t("lockUserLabel") : $t("unlockUserLabel")
                }}</span>
        </v-card-title>

        <v-card-text v-if="isLock">
          <v-container>
            <v-row>
              <p class="body-1 text-center">
                {{ $t("lockUserText") }}
              </p>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-text v-else>
          <v-container>
            <v-row>
              <p class="body-1 text-center">{{ $t("unlockUserText") }}</p>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-center align-center">
          <v-btn v-if="isLock" min-width="150" class="white--text px-10" color="red" @click="lockUser()">
            {{ $t("lockUserLabel") }}
          </v-btn>

          <v-btn v-else min-width="150" class="white--text px-10" color="green" @click="unlockUser()">
            {{ $t("unlockUserLabel") }}</v-btn>

          <v-btn min-width="150" class="primary px-2" color="" @click="() => (lockUserDialog = false)">
            {{ $t("cancelLabel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import WertheimSalesUserType from "../auth/userTypes";
  export default {
    data() {
      return {
        options:{},
        page: 1,
        pageCount: 1,
        amount: 5,
        sortBy: '',
        sortDesc: null,
        showLockUnlockBox: false,
        selectedUser: {},
        isLock: false,
        isUnlock: false,
        loadingBlock: false,
        lockSuccessful: false,
        lockUserDialog: false,
        createUserDialog: false,
        wertheimCompany: {},
        newWTSUser: {
          firstName: "",
          lastName: "",
          email: "",
          personalNumber: "",
        },
        newWTSUserRules: {
          name: [
            val => !!val || this.$t('requiredValueLabel')
          ],
          lastName: [
            val => !!val || this.$t('requiredValueLabel')
          ],
          email: [
            v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
          ],
          number: [v => {
            if (!v.trim()) return true;
            if (!isNaN(parseFloat(v))) return true;
            return 'The value has to be a number';
          }, ],
        },
        loading: false,
        users: {
          search: "",
          headers: [{
              text: this.$t('usersNameLabel'),
              value: "userFullName",
            },
            {
              text: this.$t('usersEmailLabel'),
              value: "email",
            },
            {
              text: this.$t('usersPersonalNoLabel'),
              value: "personalNo",
            },
            {
              text: this.$t('usersStatusLabel'),
              value: "active",
            },

            {
              text: "",
              sortable: false,
              value: "actions",
              align: "end",
            },
          ],
          values: [],
          footerProps:{
            'items-per-page-options' : [5, 10, 15, 20, -1],
            'disable-pagination': true,
            'next-icon': null,
            'prev-icon': null,
            'page-text' : '',
            'items-per-page-all-text': this.$t('allLabel'),
            'items-per-page-text': this.$t('rowsPerPageLabel')
          }
        },
        snackbar: {
          show: true,
          message: "",
        }
      };
    },
    props:{
      companyId: Number
    },
    watch: {
      options: {
        handler(){
          const options = this.options;
          this.amount = options.itemsPerPage
          const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
          const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
          this.sortBy = sortBy;
          this.sortDesc = sortDesc;
          this.getWertheimSales();
        },
        deep: true
      }
    },
    methods: {
      registerUser() {
        const userData = {
          FirstName: this.newWTSUser.firstName,
          LastName: this.newWTSUser.lastName,
          Email: this.newWTSUser.email,
          PersonalNumber: this.newWTSUser.personalNumber,
          UserType: WertheimSalesUserType.WertheimSales,
          CompanyId: this.wertheimCompany.id,
        };
        this.axios
          .post("api/user/create", userData)
          .then((response) => {
            this.users.values.push(response.data);
            this.createUserDialog = false;
            this.newWTSUser = {};
            this.snackbar.message = this.$t("wertheimSalesAddedLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
          })
          .catch((error) => {
            console.log(error)
            this.loading = false;
            // this.snackbar.message = error.message
            // this.$EventBus.$emit("snackbar", this.snackbar);
          });
      },

      getWertheimSales() {
        this.loading = true;
        this.axios
          .get("api/user/getWertheimSales", {
            params: {
              amount: this.amount,
              page: this.page,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc
            }
          })
          .then((response) => {
            this.pageCount = response.data.pages;
            this.users.values = response.data.users;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },

      getWertheimCompany() {
        this.axios
          .get("api/company/getWertheimCompany")
          .then((response) => {
            this.wertheimCompany = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },

      lockUser() {
        var data = {
          Id: this.selectedUser.id,
        };
        this.axios
          .post("api/user/lockuser", data)
          .then((response) => {
            let index = this.users.values
              .map((item) => {
                return item.id;
              })
              .indexOf(this.selectedUser.id);
            this.users.values.splice(index, 1, response.data);
            this.selectedUser = {};
            this.isLock = false;
            this.isUnlock = false;
            this.lockUserDialog = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },

      unlockUser() {
        var data = {
          Id: this.selectedUser.id,
        };
        this.axios
          .post("api/user/unlockuser", data)
          .then((response) => {
            let index = this.users.values
              .map((item) => {
                return item.id;
              })
              .indexOf(this.selectedUser.id);

            this.users.values.splice(index, 1, response.data);
            this.selectedUser = {};
            this.isLock = false;
            this.isUnlock = false;
            this.lockUserDialog = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      },
    },
    mounted() {
      this.getWertheimSales();
      this.getWertheimCompany();
    },
    computed: {
      // firstName: "",
      // lastName: "",
      // email: "",
      // personalNumber: "",
      validated() {
        if (this.newWTSUser.firstName && this.newWTSUser.lastName && this.newWTSUser.email && this.newWTSUser
          .personalNumber) {
          if (!isNaN(parseFloat(this.newWTSUser.personalNumber)) && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
              this.newWTSUser.email)) {
            return true
          }
        }
        return false
      }
    },
  };
</script>